var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addForm" },
    [
      _vm._l(_vm.roleFormList, function (item, index) {
        return _c(
          "el-form",
          {
            key: index,
            attrs: { model: _vm.roleForm, "label-width": "300px" },
          },
          [
            _c("div", { staticClass: "formtTitle" }, [
              _vm._v(_vm._s(item.title)),
            ]),
            _vm._v(" "),
            _vm._l(item.roles, function (i, j) {
              return _c(
                "el-form-item",
                { key: j, attrs: { label: i.label, required: "" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: i.radio,
                        callback: function ($$v) {
                          _vm.$set(i, "radio", $$v)
                        },
                        expression: "i.radio",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [_vm._v("是")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "2" } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c("el-button", { attrs: { type: "primary", size: "small" } }, [
            _vm._v("保存"),
          ]),
          _vm._v(" "),
          _c("el-button", { attrs: { type: "danger", size: "small" } }, [
            _vm._v("重置"),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }